import { surveyGetForAPP, surveyMemberGetSurveyMemberCommodityForAPP, surveyRelationshipSurveyMember } from '@/api/skin-test-coupon';
import { alert } from '@/utils/prompt';
import { getSurveyCommitId } from '@/utils/local';

const state = {
  survey: {
    enableLoginType: '', // 授权登录类型：NO_LOGIN,PREFIX_LOGIN,POSTFIX_LOGIN,可用值:NO_LOGIN,PREFIX_LOGIN,POSTFIX_LOGIN
    id: '', // // 问卷ID
    surveyType: '', // 问卷类型 NORMMAL-普通；RECOMMON-商品推荐
    guideBackgroundUrl: '', // 引导页背景图
    guideButtonUrl: '', // 引导页按钮
    enableLoading: '', // 是否启用加载页：0-不启用，1-启用
    enableFixRecommend: '', // 是否启用固定推荐商品：0-不启用，1-启用
    loadingBackgroundUrl: '', // 加载页背景图
    resultFeatureContent: '', // 结果页微页面
    surveyPartList: [
      {
        id: '',
        partPageTitle: '', // 问卷页标题
        surveyQuestions: [
          {
            value: '',
            id: '',
            title: '',
            type: '', // RADIO-单选，CHECKBOX-多选，COMPLETION-填空题，ADDRESS-地址题
            izRequired: '', // 是否必填：0-非必填，1-必填
            maxChoice: 1, // 最多选择项
            surveyAnswerList: [
              {
                id: '',
                answerDescribe: '',
              },
            ],
          },
        ],
      },
    ],
  },
  surveyCommodity: {
    surveyId: '', // 问卷ID
    memberId: '',
    memberIconUrl: '',
    memberNickName: '',
    skinProblem: '', // 对应肌肤问题
    surveyRecommendCommodityList: [
      {
        commodityId: '',
        commodityName: '',
        skuId: '',
        skinProblem: '', // 肌肤问题
        productEffect: '', // 产品功效
        productSellingPointUrl: '', // 产品卖点图
        commodityWindowUrl: '', // 商品橱窗图
      },
    ],
    surveyFixedCommodityList: [
      {
        commodityId: '', // 商品ID
        commodityName: '', // 商品名称
        skuId: '', // sku ID
        commodityWindowUrl: '', // 商品橱窗图
      },
    ],
  },
};
const actions = {
  // 匿名问卷关联用户
  relationshipSurveyMember({ state, rootState }) {
    // // 无需登陆提交问卷id
    const surveyCommitId = getSurveyCommitId();
    const { survey } = state;
    // 后置登陆，登陆后关联用户
    if (survey.enableLoginType === 'POSTFIX_LOGIN' && surveyCommitId) {
      surveyRelationshipSurveyMember({
        id: surveyCommitId,
        memberId: rootState.memberCO.id,
      }).then(() => {});
    }
  },
  fetchSurveyGetForAPP({ commit }, id) {
    surveyGetForAPP({ id }).then(res => {
      const { success, data, msg } = res;
      if (!data.surveyPartList) {
        data.surveyPartList = [];
      }
      if (success && data) {
        data.surveyPartList.forEach(item => {
          item.surveyQuestions.forEach(item => {
            const { surveyAnswerList, type } = item;
            // 问卷题目填写的答案
            item.value = '';
            // 前端校验错误文案
            item.errText = '';
            // 单选题默认选择第一个
            if (type === 'RADIO') {
              item.value = surveyAnswerList[0].id;
            }
          });
        });
        commit('$uStore', {
          name: 'skinTestCoupon.survey',
          value: data,
        });
      } else {
        alert(msg);
      }
    });
  },
  fetchSurveyMemberCommodit({ commit }, data) {
    surveyMemberGetSurveyMemberCommodityForAPP(data).then(res => {
      const { success, data, msg } = res;
      if (success && data) {
        commit('$uStore', {
          name: 'skinTestCoupon.surveyCommodity',
          value: data,
        });
      } else {
        alert(msg);
      }
    });
  },
};
export default {
  state,
  actions,
};
